import createIcon from '../../createIcon';

/**
 * @component @name TrendingFlat
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNSAxMkwxNy41IDhWMTFIMi41VjEzSDE3LjVWMTZMMjEuNSAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TrendingFlat = createIcon('TrendingFlat', [
  ['path', { d: 'M21.5 12L17.5 8V11H2.5V13H17.5V16L21.5 12Z', key: '1azg44' }],
]);

export default TrendingFlat;
